<template>
  <article>
    <vuelidate-form :validator="$v.validationData" :validator-params="{ filed: $t('MCOM-0000001') }">
      <div :class="['form-text-field', $v.$error ? 'error' : '']">
        <div class="input-text-field half">
          <input
            class="form-control"
            type="password"
            :id="id"
            v-on="NOS_INSTANCE.listeners()"
            npkencrypt="on"
            data-keypad-type="number"
            data-keypad-theme="mobile"
            data-keypad-extend-ui="pw"
            data-keypad-next="__hide__"
            maxlength="4"
            :value="validationData"
          />
        </div>
      </div>
    </vuelidate-form>
  </article>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  name: "AcnoPassword",
  components: {},
  props: {
    id: {
      default: "password",
    },
    NOS_INSTANCE_REFERANCE: {
      required: true,
      default: () => undefined,
    },
  },
  data() {
    return {
      [this.id]: "",
      NOS_INSTANCE: {},
    };
  },
  validations() {
    return {
      validationData: { required },
    };
  },
  created() {
    this.NOS_INSTANCE = this.NOS_INSTANCE_REFERANCE;
  },
  mounted() {},
  computed: {
    validationData() {
      if (this.NOS_INSTANCE.noscomponent) {
        return this.NOS_INSTANCE.noscomponent[this.id];
      } else {
        return "";
      }
    },
  },
  methods: {
    init() {
      this.NOS_INSTANCE.noscomponent[this.id] = "";
    },
  },
};
</script>
